import { GetDailyCheckInNameResponse } from '@/modules/promotion/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { DailyCheckInQueryKeys } from '@/modules/promotion/keys'
import { getDailyCheckInName } from '../../services'

export default function useQueryGetDailyCheckInName(
	props?: UseBaseQueryOptions<GetDailyCheckInNameResponse>,
) {
	return useQuery({
		queryKey: [DailyCheckInQueryKeys.GetDailyCheckInName],
		queryFn: () => getDailyCheckInName(),
		...props,
	})
}
